var exports = {
  "PT": "Markup.module__markup___VGFnRX",
  "z3": "Markup.module__bio___VGFnRX",
  "Z_": "Markup.module__mutedSpoilerContext___VGFnRX",
  "nf": "Markup.module__link___VGFnRX",
  "mG": "Markup.module__inline___VGFnRX",
  "tZ": "Markup.module__inlineFormat___VGFnRX",
  "Hy": "Markup.module__codeContainer___VGFnRX",
  "h": "Markup.module__blockquoteContainer___VGFnRX",
  "xE": "Markup.module__alert___VGFnRX",
  "CZ": "Markup.module__tableContainer___VGFnRX",
  "js": "Markup.module__latexCodeBlock___VGFnRX",
  "lB": "Markup.module__codeActions___VGFnRX",
  "vo": "Markup.module__codeActionsVisible___VGFnRX",
  "r": "Markup.module__blockquoteDivider___VGFnRX",
  "rs": "Markup.module__blockquoteContent___VGFnRX",
  "em": "Markup.module__blockquoteEmptyContent___VGFnRX",
  "tp": "Markup.module__table___VGFnRX",
  "qd": "Markup.module__tableHeader___VGFnRX",
  "xR": "Markup.module__tableCell___VGFnRX",
  "Vl": "Markup.module__alignLeft___VGFnRX",
  "Hu": "Markup.module__alignCenter___VGFnRX",
  "Wk": "Markup.module__alignRight___VGFnRX",
  "Qd": "Markup.module__alertIcon___VGFnRX",
  "Ro": "Markup.module__alertTitle___VGFnRX",
  "S9": "Markup.module__alertContent___VGFnRX",
  "FU": "Markup.module__alertNote___VGFnRX",
  "ap": "Markup.module__alertTip___VGFnRX",
  "nL": "Markup.module__alertImportant___VGFnRX",
  "vc": "Markup.module__alertWarning___VGFnRX",
  "SN": "Markup.module__alertCaution___VGFnRX",
  "lE": "Markup.module__mention___VGFnRX",
  "bG": "Markup.module__interactive___VGFnRX",
  "vE": "Markup.module__timestamp___VGFnRX",
  "CU": "Markup.module__spoilerWrapper___VGFnRX",
  "N5": "Markup.module__blockSpoilerWrapper___VGFnRX",
  "p6": "Markup.module__spoiler___VGFnRX",
  "mC": "Markup.module__blockSpoiler___VGFnRX",
  "ur": "Markup.module__spoilerContent___VGFnRX",
  "yI": "Markup.module__latexContent___VGFnRX",
  "Y4": "Markup.module__hljs___VGFnRX",
  "HQ": "Markup.module__ansiCode___VGFnRX",
  "bi": "Markup.module__ansi-code-blink___VGFnRX",
  "So": "Markup.module__error___VGFnRX",
};

module.exports = exports;
